<template>
  <div>
    <div class="py-5 flex flex-col md:flex-row justify-between items-center">
      <form @submit.prevent="submitSearch()" class="w-full md:w-auto mb-4 md:mb-0">
        <vs-input
          icon-no-border
          placeholder="Search"
          v-model="searchQuery"
          class="w-full md:w-auto input-square-full"
          icon="icon-search"
          icon-pack="feather"
        />
      </form>
      <vs-button
        @click="$router.push('/org_management/add_company')"
        class="md:w-auto"
        color="#009FB2"
        >Add Company</vs-button
      >
    </div>

    <vs-table stripe :data="lists">
      <template slot="thead">
        <!-- Column: No -->
        <vs-th @click="toggleSort('id')" class="cursor-pointer">
          <div class="flex items-center justify-center">
            <span>No</span>
          </div>
        </vs-th>

        <!-- Column: Name -->
        <vs-th @click="toggleSort('name')" class="text-left cursor-pointer">
          <div class="flex items-center">
            <span>Name</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('name')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('name', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('name', 'desc')"
              />
            </div>
          </div>
        </vs-th>

        <!-- Column: Phone -->
        <vs-th @click="toggleSort('phone')" class="text-center cursor-pointer">
          <div class="flex items-center justify-center">
            <span>Phone</span>
            <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('phone')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('phone', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('phone', 'desc')"
              />
            </div>
          </div>
        </vs-th>

        <!-- Column: Status -->
        <vs-th @click="toggleSort('status')" class="text-center cursor-pointer">
          <div class="flex items-center justify-center">
            <span>Status</span>
           <div
              class="ml-4 flex flex-col sort-icon-group"
              @click.stop="toggleSort('status')"
              style="cursor: pointer"
            >
              <font-awesome-icon
                :icon="['fas', 'caret-up']"
                :class="getSortClass('status', 'asc')"
              />
              <font-awesome-icon
                :icon="['fas', 'caret-down']"
                :class="getSortClass('status', 'desc')"
              />
            </div>
          </div>
        </vs-th>

        <vs-th class="text-center">Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr class="pln-color" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td  :data="indextr">
            {{ (currentPage - 1) * itemsPerPage + indextr + 1 }}
          </vs-td>

          <vs-td class="text-left " :data="tr.name">
            {{ tr.name }}
          </vs-td>

          <vs-td class="text-center " :data="tr.phone">
            {{ tr.phone }}
          </vs-td>

          <vs-td class="text-center " :data="tr.statusId">
            {{ tr.statusId ? "Enabled" : "Disabled" }}
          </vs-td>

          <vs-td class="text-center">
            <div class="flex justify-center gap-mini">
              <vs-tooltip text="Edit">
                <router-link :to="`/org_management/update_company/${tr.id}`">
                  <feather-icon icon="EditIcon" />
                </router-link>
              </vs-tooltip>
              <vs-tooltip text="Delete">
                <a href="" @click.prevent="conformDelete(tr.id)">
                  <feather-icon icon="TrashIcon" />
                </a>
              </vs-tooltip>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <!-- Pagination -->
    <div class="flex justify-between mt-4">
      <div class="flex items-center">
        <span class="mr-2">Show data</span>
        <vs-select
          class="items-per-page"
          v-model="itemsPerPage"
          @input="updateItemsPerPage"
        >
          <vs-select-item
            v-for="(option, index) in pageOptions"
            :key="index"
            :value="option.value"
            :text="option.text"
          />
        </vs-select>
      </div>

      <CustomPagination
        :current-page.sync="currentPage"
        :total-pages="totalPages"
        :total-data="totalData"
        @update:currentPage="getCompanyLists"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import CustomPagination from "@/components/CustomPagination.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCaretUp, faCaretDown);

export default {
  components: {
    CustomPagination,
    "font-awesome-icon": FontAwesomeIcon,
  },
  data() {
    return {
      selectedId: "",
      searchQuery: "",
      itemsPerPage: 10,
      currentPage: 1,
      totalData: 0,
      totalPages: 0,
      lists: [],
      sortField: "",
      sortOrder: "asc",
      pageOptions: [
        { value: 10, text: "10" },
        { value: 25, text: "25" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
    };
  },
  mounted() {
    this.getCompanyLists();
  },
  methods: {
    //Update item pages (handling for change limit of page)
    updateItemsPerPage() {
      this.currentPage = 1;
      this.getCompanyLists();
    },
    submitSearch() {
      this.currentPage = 1;
      this.getCompanyLists();
    },
    getCompanyLists() {
      this.$vs.loading();
      const params = {
        search: this.searchQuery,
        page: this.currentPage,
        limit: this.itemsPerPage,
      };

      if (this.sortField) {
        const sortField =
          this.sortField === "status" ? "statusId" : this.sortField;
        params.sort = `${sortField} ${this.sortOrder}`;
      }

      console.log("📦 [getCompanyLists] API Params:", params);

      api
        .companies(params)
        .then((result) => result.data)
        .then((data) => {
          console.log("✅ [getCompanyLists] Response:", data);
          if (data.status) {
            this.lists = data.data;
            this.totalData = data.totalData;
            this.totalPages = data.maxPage;
            this.$store.dispatch("updateCompanyLists", data.data);
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [getCompanyLists] Error:", e);
          this.$vs.loading.close();
        });
    },
    toggleSort(field) {
      console.log("🔽 [toggleSort] Clicked field:", field);

      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }

      console.log("🔄 [toggleSort] New sortField:", this.sortField);
      console.log("🔄 [toggleSort] New sortOrder:", this.sortOrder);

      this.getCompanyLists();
    },
    getSortClass(field, direction) {
      const isActive = this.sortField === field && this.sortOrder === direction;
      return {
        "sort-icon": true,
        active: isActive,
      };
    },
    conformDelete(id) {
      this.selectedId = id;
      this.$vs.dialog({
        color: "danger",
        title: `Confirm Delete`,
        text: "Are you sure will delete this data?.",
        accept: this.doDelete,
      });
    },
    doDelete() {
      this.$vs.loading();
      api
        .deleteCompany({ id: this.selectedId })
        .then((result) => result.data)
        .then((data) => {
          this.selectedId = "";
          console.log("🗑 [doDelete] Delete response:", data);
          this.$vs.notify({
            title: "Success",
            text: "Delete data success",
            color: "success",
            position: "top-right",
          });
        })
        .finally(() => {
          this.getCompanyLists();
          this.$vs.loading.close();
        })
        .catch((e) => {
          console.error("❌ [doDelete] Error:", e);
          this.$vs.notify({
            title: "Failed",
            text: "Delete data failed",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-center::v-deep .vs-table-text {
  justify-content: center;
}
.text-right::v-deep .vs-table-text {
  justify-content: flex-end;
}
.cursor-pointer {
  cursor: pointer;
}
.items-per-page {
  width: 80px;
}
::v-deep .items-per-page .vs-select {
  width: 100%;
}
</style>
